var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-map ls"},[_c('vue-amap',{ref:"amap",attrs:{"d3-features":['bg', 'road', 'point'],"bounds":_vm.bounds,"zoom":10,"center":_vm.center},on:{"complete":_vm.setMarkers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }